import { render, staticRenderFns } from "./diseaseCard.vue?vue&type=template&id=9f11199e&scoped=true&"
import script from "./diseaseCard.vue?vue&type=script&lang=js&"
export * from "./diseaseCard.vue?vue&type=script&lang=js&"
import style0 from "./diseaseCard.vue?vue&type=style&index=0&id=9f11199e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f11199e",
  null
  
)

export default component.exports